export const FlightPathUserIdClaimKey = "flightPathUserId";
export const FlightPathUserOrganisationIdsClaimKey = "flightPathUserOrganisationIds";
